import { useEffect, useState } from 'react'
import { sortBy } from 'lodash'
import useCustomEndpoint, { VALID_ENDPOINTS } from '../../../../hooks/useCustomEndpoint'

export default function useBrands() {
  const [mainContent, setMainContent] = useState({
    brands_title_list: [],
    brands_body_list: [],
  })
  const [currentBrand, setCurrentBrand] = useState(null)

  const { data } = useCustomEndpoint({ type: VALID_ENDPOINTS.brandsWithHotels })

  const selectNewCurrentBrand = (_id) => {
    const brand = mainContent.brands_body_list.find((brand) => brand.id === _id)
    setCurrentBrand(brand)
  }

  useEffect(() => {
    if (data) {
      const orderedData = sortBy(data, ['order'])
      const isList = Array.isArray(orderedData) && orderedData?.length > 0
      const first_brand = isList ? orderedData[0] : {}
      setMainContent({
        brands_title_list: isList
          ? orderedData.map((brand) => ({ title: brand.name, id: brand.slug }))
          : [],
        brands_body_list: isList
          ? orderedData.map((brand) => ({
              name: brand?.acf?.short_name ?? brand?.name ?? '',
              id: brand.slug,
              content: brand?.acf?.informationAboutTheBrand ?? '',
              image: brand?.acf?.featuredImage?.url,
              hotels: brand?.hotels?.map((hotel) => ({
                name: hotel?.acf?.info?.name ?? hotel?.name,
                link: hotel?.link ?? '/#',
              })),
            }))
          : [],
      })
      // Set current Brand
      setCurrentBrand({
        name: first_brand?.name ?? '',
        id: first_brand.slug,
        content: first_brand?.acf?.informationAboutTheBrand ?? '',
        image: first_brand?.acf?.featuredImage?.url,
        hotels: first_brand?.hotels?.map((hotel) => ({
          name: hotel?.name,
          link: hotel?.link ?? '/#',
        })),
      })
    }
  }, [data])

  return {
    mainContent,
    currentBrand,
    selectNewCurrentBrand,
  }
}
